export default function(playlistText) {
  return playlistText.indexOf('#EXT-X-ENDLIST') < 0;
}
